import { render } from "./DynamicImageContainer.vue?vue&type=template&id=846f4838"
import script from "./DynamicImageContainer.vue?vue&type=script&lang=js"
export * from "./DynamicImageContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__